angular.module('lf.desktop')

.directive('drawerBox', function () {
  return {
    restrict: 'EA',
    link: function (scope, el, attrs) {
      var $box = el;
      var $drawers = $box.find('.drawer');
      var boxWidth = $box.width() | 0;
      var boxHeight = $box.height() | 0;
      var drawerWidth = boxWidth / $drawers.length | 0;

      $drawers
        .css({
          width: drawerWidth,
          height: boxHeight
        })
        .each(function (index) {
          var $drawer = $(this);
          var left = index * drawerWidth;
          var right = left + drawerWidth;

          $drawer
            .data('drawer.left', left)
            .css('left', left);
          $drawer.data('drawer.state', {});

          var $content = $box.find('.drawer__content').eq(index);
          $content.css('clip', [
            'rect(0 ',
            right + 'px',
            boxHeight + 'px',
            left + 'px)'
          ].join(' '));

          var $closeButton = $('<div class="drawer__close-button"><i class="fa fa-times-circle"></i></div>');
          $content.append($closeButton);
        });

      $drawers
        .on('mouseenter', onDrawerMouseEnter)
        .on('mouseleave', onDrawerMouseLeave)
        .on('click', onDrawerClick);

      function onDrawerMouseEnter (e) {
        var $drawer = $(this);
        var states = {
          $closed: $drawer.find('.drawer__closed'),
          $rollover: $drawer.find('.drawer__rollover')
        }
        states.$closed.hide();
        states.$rollover.show();
      }

      function onDrawerMouseLeave (e) {
        var $drawer = $(this);
        var states = {
          $closed: $drawer.find('.drawer__closed'),
          $rollover: $drawer.find('.drawer__rollover')
        }
        states.$rollover.hide();
        states.$closed.show();
      }

      function onDrawerClick (e) {
        e.preventDefault();
        var $drawer = $(this);
        var state = $drawer.data('drawer.state');
        var isExpanded = state.isExpanded;

        if (state.inTransition) return;

        state.inTransition = true;

        if (!isExpanded) {
          var index = $drawer.index();
          var $contentContainer = $box.find('.drawer__content-container');
          var $content = $box.find('.drawer__content').eq(index);
          $drawer.css('z-index', 30);

          $contentContainer.show();
          $content.show();
//        $drawer.velocity({ opacity: 0 }, { duration: 100, display: 'none' });
          $drawer.css('opacity', 0).hide();
          $content.velocity({
            clipLeft: 0,
            clipRight: boxWidth
          }, {
            duration: 500,
            easing: 'easeOutExpo',
            complete: function () {
              state.isExpanded = true;
              state.inTransition = false;

              $box.trigger('drawer.expand', { index: index, drawer: $drawer[0] });
            }
          });
        }
      }

      $box.on('click', '.drawer__content .drawer__close-button', onCloseButtonClick);

      function onCloseButtonClick (e) {
        e.preventDefault();
        var $content = $(this).closest('.drawer__content');
        var index = $content.index();
        var $drawer = $drawers.eq(index);

        var drawerLeft = $drawer.data('drawer.left');
        var drawerState = $drawer.data('drawer.state');

        $content.velocity({
          clipLeft: drawerLeft,
          clipRight: drawerLeft + drawerWidth
        }, {
          duration: 300,
          easing: 'easeOutExpo',
          complete: function () {
            $drawer
              .velocity({
                opacity: 1
              }, {
                duration: 50,
                display: 'block',
                complete: function () {
                  $content.hide();
                  $content.parent().hide();
                  $drawer.css('z-index', 10);
                  drawerState.inTransition = false;
                  drawerState.isExpanded = false;

                  $box.trigger('drawer.close', { index: index, drawer: $drawer[0] });
                }
              });
          }
        });
      }

      function onDestroy () {
        $box.off('click', '.drawer__content .drawer__close-button', onCloseButtonClick);
        $drawers
          .off('mouseenter', onDrawerMouseEnter)
          .off('mouseleave', onDrawerMouseLeave)
          .off('click', onDrawerClick);
      }

      scope.$on('destroy', onDestroy);
    }
  }
});
